import { connect } from "react-redux";
import ReportTicketLog from "../components/Report/TicketLog";

const ReportTicketLogPage = ({ accessToken, currentLang }) => {
  return (
    <ReportTicketLog accessToken={accessToken} currentLang={currentLang} />
  );
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(ReportTicketLogPage);
